import { Utils } from '@pacem/pacem-core';
import { VERTEX_OUTPUT_LOCATION_NORMAL, VERTEX_OUTPUT_LOCATION_VERTEX, VERTEX_OUTPUT_LOCATION_UV, VERTEX_OUTPUT_LOCATION_INDEX, VERTEX_OUTPUT_LOCATION_RAY, VERTEX_OUTPUT_LOCATION_INSTANCE, MATERIAL_GROUP_INDEX, STORAGE_MATERIAL_INDEX, VERTEX_COLOR_REFERENCE, LIGHTING_COLOR_REFERENCE, AMBIENT_COLOR_REFERENCE } from '../constants';
const DefaultBasicMaterialFragmentOptions = {
    outputNormalLocation: VERTEX_OUTPUT_LOCATION_NORMAL,
    outputVertexLocation: VERTEX_OUTPUT_LOCATION_VERTEX,
    outputUvLocation: VERTEX_OUTPUT_LOCATION_UV,
    outputVertexIndexLocation: VERTEX_OUTPUT_LOCATION_INDEX,
    outputRayIndexLocation: VERTEX_OUTPUT_LOCATION_RAY,
    outputInstanceIndexLocation: VERTEX_OUTPUT_LOCATION_INSTANCE,
    storageMaterialGroupIndex: MATERIAL_GROUP_INDEX,
    storageMaterialBindingIndex: STORAGE_MATERIAL_INDEX,
};
function adaptWGSLStringArray(array = []) {
    return array.join('\r\n');
}
function adaptWGSLModifierStringArray(array = []) {
    let output = '';
    for (let modifier of array) {
        const trimmed = modifier.trim();
        if (trimmed.endsWith(';')) {
            output += (trimmed + '\r\n\t');
        }
        else {
            output += `${VERTEX_COLOR_REFERENCE} = ${trimmed};\r\n\t`;
        }
    }
    return output;
}
export function getBasicMaterialFragmentWgsl(extensions = {}, options = DefaultBasicMaterialFragmentOptions) {
    const opts = Utils.extend({}, DefaultBasicMaterialFragmentOptions, options);
    const definitions = adaptWGSLStringArray(extensions.definitions), bindings = adaptWGSLStringArray(extensions.bindings), modifiers = adaptWGSLModifierStringArray(extensions.modifiers);
    const color = VERTEX_COLOR_REFERENCE, lighting = LIGHTING_COLOR_REFERENCE, ambient = AMBIENT_COLOR_REFERENCE;
    return `// definitions

${definitions}

// bindings
@group(${opts.storageMaterialGroupIndex}) @binding(${opts.storageMaterialBindingIndex}) var<storage, read> diffuseColor: vec4f;
${bindings}

const empty = vec4f(0,0,0,0);
const white = vec4f(1,1,1,1);

@fragment fn main (
    @builtin(position) position: vec4f,                                                 // clip-space position
    @location(${opts.outputNormalLocation}) normal: vec3f,                              // world-space normal
    @location(${opts.outputVertexLocation}) vertex: vec3f,                              // world-space position
    @location(${opts.outputUvLocation}) uv: vec2f,
    @location(${opts.outputVertexIndexLocation}) @interpolate(flat) index: u32,         // vertex index,
    @location(${opts.outputRayIndexLocation}) ray: vec3f,                               // ray (eye-to-vertex) vector
    @location(${opts.outputInstanceIndexLocation}) @interpolate(flat) instance : u32,   // instance index
) -> @location(0) vec4f {
    var ${color} = diffuseColor;
    var ${ambient}: vec4f = empty;
    var ${lighting}: vec4f = empty;

    // modifiers
    ${modifiers}

    ${lighting} = select(white, ${lighting}, ${lighting}.a > 0);
    return ${color} * ${lighting} + ${ambient};
}`;
}
